import {
  PostBulletinInterface,
  DeleteBulletinInterface,
  UpdateBulletinInterface,
} from '@/data/payload/contracts/BulletinRequest'
import { TouchSwipe } from 'quasar'

export class UpdateBulletinRequest implements UpdateBulletinInterface {
  private title: string
  private fileCode: string
  private imageThumbnailId: number
  private isActive: boolean
  private isRecommended: boolean
  private fileName: string
  private fileByte: string
  private fileUpload: any
  private expireddate: string

  constructor(
    title: string,
    fileCode: string,
    imageThumbnailId: number,
    isActive: boolean,
    isRecommended: boolean,
    fileName: string,
    fileByte: string,
    fileUpload: any,
    expireddate: string
  ) {
    this.title = title
    this.fileCode = fileCode
    this.imageThumbnailId = imageThumbnailId
    this.isActive = isActive
    this.isRecommended = isRecommended
    this.fileName = fileName
    this.fileByte = fileByte
    this.fileUpload = fileUpload
    this.expireddate = expireddate
  }
  public toJSON() {
    if (this.fileByte === '') {
      const data = {
        title: this.title,
        file_code: this.fileCode,
        image_thumbnail_id: this.imageThumbnailId,
        is_active: this.isActive,
        is_recommended: this.isRecommended,
        expireddate: this.expireddate,
      }
      return JSON.stringify({
        data,
      })
    } else {
      const data = {
        title: this.title,
        file_code: this.fileCode,
        image_thumbnail_id: this.imageThumbnailId,
        is_active: this.isActive,
        is_recommended: this.isRecommended,
        file_name: this.fileName,
        file_byte: this.fileByte,
        expireddate: this.expireddate,
      }
      return JSON.stringify({
        data,
      })
    }
  }

  public toFormData() {
    if (this.fileUpload === null) {
      const data = new FormData()
      data.append('title', this.title)
      data.append('fileCode', this.fileCode)
      data.append('imageThumbnailId', this.imageThumbnailId.toString())
      data.append('isActive', this.isActive ? '1' : '0')
      data.append('isRecommended', this.isRecommended ? '1' : '0')
      data.append('expireddate', this.expireddate)
      return data
    } else {
      const data = new FormData()
      data.append('title', this.title)
      data.append('fileCode', this.fileCode)
      data.append('fileUpload', this.fileUpload)
      data.append('imageThumbnailId', this.imageThumbnailId.toString())
      data.append('isActive', this.isActive ? '1' : '0')
      data.append('isRecommended', this.isRecommended ? '1' : '0')
      data.append('expireddate', this.expireddate)
      return data
    }
  }
}
export class DeleteBulletinRequest implements DeleteBulletinInterface {
  private ids: number

  constructor(ids: any) {
    this.ids = ids
  }
  public toJSON() {
    const Ids = this.ids
    return JSON.stringify({
      Ids,
    })
  }
}

export class BulletinApiRequest implements PostBulletinInterface {
  private title: string
  private fileCode: string
  private imageThumbnailId: number
  private isActive: boolean
  private isRecommended: boolean
  private fileName: string
  private fileByte: string
  private fileUpload: any
  private owner_id: string
  private expireddate: string

  constructor(
    title: string,
    fileCode: string,
    imageThumbnailId: number,
    isActive: boolean,
    isRecommended: boolean,
    fileName: string,
    fileByte: string,
    fileUpload: any,
    expireddate: string,
    owner_id: string
  ) {
    this.title = title
    this.fileCode = fileCode
    this.imageThumbnailId = imageThumbnailId
    this.isActive = isActive
    this.isRecommended = isRecommended
    this.fileName = fileName
    this.fileByte = fileByte
    this.fileUpload = fileUpload
    this.expireddate = expireddate
    this.owner_id = owner_id
  }
  public toJSON() {
    const data = {
      title: this.title,
      file_code: this.fileCode,
      image_thumbnail_id: this.imageThumbnailId,
      is_active: this.isActive,
      is_recommended: this.isRecommended,
      file_name: this.fileName,
      file_byte: this.fileByte,
      expireddate: this.expireddate,
      owner_id: this.owner_id,
    }
    return JSON.stringify({
      data,
    })
  }

  public toFormData() {
    const data = new FormData()
    data.append('title', this.title)
    data.append('fileCode', this.fileCode)
    data.append('fileUpload', this.fileUpload)
    data.append('imageThumbnailId', this.imageThumbnailId.toString())
    data.append('isActive', this.isActive ? '1' : '0')
    data.append('isRecommended', this.isRecommended ? '1' : '0')
    data.append('expireddate', this.expireddate)
    data.append('ownerIds', this.owner_id)
    return data
  }
}
